export const DEV = "DEV";
export const PRE = "PRE";
export const PRO = "PRO";